/**
 * @legacy
 * @prev administration/templates/administration/reseller/customer_suspend.html
 */
document.getElementById('id_users_1').onclick = function () {
  var checkboxes = document.getElementsByName('users')
  for (var checkbox of checkboxes) {
    checkbox.checked = this.checked
  }
}
